export default {
  raffleId: null,
  fetching: false,
  comments: [],
};
